<template>
    <div
        class="app_checkbox"
        :class="{ app_checkbox_inline: inline, 'w-full': isFull }"
    >
        <input
            class="app_checkbox_input"
            :checked="checked"
            :name="name"
            type="checkbox"
            :id="id"
            :value="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"
        />
        <label
            class="app_checkbox_label"
            :class="{ 'w-full': isFull }"
            :for="id"
        >
            <span
                class="app_checkbox_icon"
                :class="[
                    // large ? 'large' : '',
                    // bgWhite ? 'bg_white' : '',
                    // isSingle ? 'check_icon_single' : '',
                    checked ? 'inline-block' : '!hidden',
                ]"
            >
                    <fa :icon="['fal', 'check']"></fa>
            </span>
            <template v-if="text">
                {{ text }}
            </template>
            <slot name="checkboxLabel"></slot>
        </label>
    </div>
</template>

<script>
export default {
    name: 'AppCheckbox',
    props: {
        bgWhite: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            default: false,
        },
        id: {
            type: [String, Number],
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        checked: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        large: {
            type: Boolean,
            default: false,
        },
        isSingle: {
            type: Boolean,
            default: false,
        },
        isFull: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const isChecked = () => {
            console.log('check');
        };
        return {
            isChecked,
        };
    },
};
</script>

<style scoped>
.app_checkbox {
    @apply flex items-center;
}

.app_checkbox.app_checkbox_inline {
    @apply inline-block ltr:mr-2 rtl:ml-2;
}

.app_checkbox input[type='checkbox'].app_checkbox_input {
    @apply opacity-0 hidden;
}

.app_checkbox_icon {
    @apply inline-flex flex-shrink-0 items-center justify-center relative text-blue-500;
}

.app_checkbox_icon.success {
    @apply border-blue-500;
}

.app_checkbox_icon.danger {
    @apply border-red-500;
}

.app_checkbox_icon.large {
    @apply w-8 h-8;
}

/* .app_checkbox_icon svg {
    @apply hidden w-4 h-3 absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4;
} */

.app_checkbox_label {
    @apply flex items-center cursor-pointer text-sm text-gray-500 dark:text-white;
}

input[type='checkbox']:checked + label .app_checkbox_icon svg {
    @apply inline-block text-lg text-blue-500 mr-1;
}

/* input[type='checkbox']:checked + label > .app_checkbox_icon {
    @apply bg-green-500 border-green-500;
} */

input[type='checkbox']:checked + label > .app_checkbox_icon.check_icon_single {
    @apply border border-gray-200 bg-gray-100;
}

input[type='checkbox']:checked
    + label
    > .app_checkbox_icon.check_icon_single
    svg {
    @apply text-green-500 text-xl;
}

.bg_white {
    @apply bg-white dark:bg-black-900;
}
</style>
